module.exports = __webpack_public_path__ + "static/img/solution1.cf0cdca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution1.png
// module id = M3XI
// module chunks = 1